<template>
    <basic-page addedclass="white-bg" 
        class="cookie-policy" 
        :pagedata="this.pageData" 
        :bannerimg="backgroundImage">

        <div class="container-espe white-bg">
            <h2>Work in progress ...</h2>    
        </div>

    </basic-page>
</template>

<script>
import BasicPage from './BasicPage.vue'
import { fetchSingleNode, fetchSinglePage } from '../libs/drupalClient'
export default {
    components: { BasicPage },
    name: 'diventa-un-esperto',
    data: () => {
        return {
            pageData: { 
                attributes: {
                    title: "",
                    body: {
                        summary: ""
                    }
                } 
            },
            formData: {
                Nome: "",
                Cognome: "",
                Email: "",
                Cellulare: "",
                Autorizzo: false,
                Message: ""
            },
            currentPageId: "f32f8dcf-052c-4456-9dea-417dd7a17753",
            bannerData: {},
            name: "Experotary",
            email: "experotary@info.it", 
            website: "experotary.com"
        }
    },
    computed: {
        lang() {
            return this.$store.state.currentLang
        },
        defaultLang() {
            return this.$store.state.defaultLang
        },
        backgroundImage() {
            if(this.bannerData.field_banner_top)
                return this.bannerData
            else 
                return {}
        }
    },
    mounted() {
        fetchSinglePage('page_type_02', this.currentPageId, { include: ['field_ref_banner_top'] }, this.lang)
        .then(res => {
            this.pageData = res[0]

            fetchSingleNode('banner', this.pageData.field_ref_banner_top.id, { include: ['field_banner_top'] }, this.lang)
            .then(res => {
                this.bannerData = res[0]
            })
        })
    }
}
</script>

<style lang="scss">
</style>